(() => {
  // app/scripts/view-toggle.js
  var LOCAL_STORAGE_KEY = "view-toggle";
  var ViewToggle = class extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector("input");
      this.handleChange = this.handleChange.bind(this);
    }
    connectedCallback() {
      if (!this.input)
        return;
      this.applyStoredViewMode();
      this.input.addEventListener("change", this.handleChange);
    }
    disconnectedCallback() {
      if (!this.input)
        return;
      this.input.removeEventListener("change", this.handleChange);
    }
    handleChange() {
      const { checked } = this.input;
      const viewMode = checked ? "list-view" : "grid-view";
      localStorage.setItem(LOCAL_STORAGE_KEY, viewMode);
      this.applyViewMode(viewMode);
    }
    applyStoredViewMode() {
      this.applyViewMode(localStorage.getItem(LOCAL_STORAGE_KEY));
    }
    applyViewMode(viewMode) {
      const targetSelector = this.dataset.target;
      const classNames = (this.dataset.className || "").split(",").filter(Boolean);
      const target = targetSelector ? document.querySelector(targetSelector) : null;
      const shouldUseListView = viewMode ? viewMode === "list-view" : this.input.checked;
      this.input.checked = shouldUseListView;
      if (!target || !classNames.length)
        return;
      classNames.forEach((className) => {
        target.classList.toggle(className, shouldUseListView);
      });
    }
  };
  if (!customElements.get("view-toggle")) {
    customElements.define("view-toggle", ViewToggle);
  }
})();
